import { createContext } from 'react';
/** `Grid` sets the gutter once; every `Column` reads it back through here. */
export const GridContext = createContext({});
